import React from 'react'
import { MdArrowOutward } from 'react-icons/md'
import { FaGithub } from 'react-icons/fa6'
import { GITHUB_PROFILE } from './work/projectData'
import { RevealLine } from './ui/Reveal'
import { WorkCursorPreview } from './work/WorkCursorPreview'
import { WorkSpreads } from './work/WorkSpreads'

// `variant` picks the layout:
//   'cursor'  — editorial row list with a cursor-tracking preview (homepage)
//   'spreads' — alternating full-width image / copy bands (/projects page)
export const ProjectSection = ({ variant = 'cursor' }) => {
  const isSpreads = variant === 'spreads'

  return (
    <section id="work" className=" px-6 md:px-10 py-24 md:py-32 border-b border-ink/10">
      <div className=" max-w-7xl mx-auto">
        <div className=" grid md:grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className=" md:col-span-3">
            <p className=" font-mono text-sm text-mint-deep">(02)</p>
            <h2 className=" font-display text-4xl md:text-5xl text-maroon mt-2 tracking-tight">
              <RevealLine>Selected Work</RevealLine>
            </h2>
          </div>
          <p className=" md:col-span-6 md:col-start-7 self-end text-base md:text-lg text-ink/60 leading-relaxed">
            {isSpreads
              ? 'Products and interfaces I’ve designed and built — scroll through, click any to visit.'
              : 'A selection of products and interfaces I’ve designed and built — hover a row to preview, click to visit.'}
          </p>
        </div>

        {isSpreads ? <WorkSpreads /> : <WorkCursorPreview />}

        {/* more on github */}
        <div className=" mt-14 md:mt-20 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className=" max-w-xl">
            <h3 className=" font-display text-2xl md:text-3xl text-maroon tracking-tight">
              There&apos;s more on GitHub
            </h3>
            <p className=" text-base text-ink/60 leading-relaxed mt-3">
              Open-source work, experiments, and side projects that didn&apos;t make the shortlist
              above all live on my GitHub.
            </p>
          </div>
          <a
            href={GITHUB_PROFILE}
            target="_blank"
            rel="noopener noreferrer"
            className=" group inline-flex items-center gap-2 shrink-0 bg-maroon text-cream text-sm font-medium px-7 py-3.5 rounded-full transition-colors duration-300 hover:bg-mint hover:text-panel w-fit"
          >
            <FaGithub className=" text-lg" />
            View more projects
            <MdArrowOutward className=" text-base transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </div>
    </section>
  )
}
